import React, { useEffect, useRef } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';

// Importação dos alertas padronizados
import { showWarning } from './utils/alertas'; 

import Mapa from './pages/Mapa';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import DetalheEmpreendimento from './pages/DetalheEmpreendimento'; 

// Componente de Proteção de Rota (Utilizado apenas em áreas 100% restritas se houver)
const RotaProtegida = ({ children }) => {
  const token = localStorage.getItem('token'); 
  return token ? children : <Navigate to="/login" />;
};

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const timerRef = useRef(null);

  // 🕒 CONFIGURAÇÃO: 1 hora (3600000 ms) de inatividade para Logoff
  const TEMPO_LIMITE = 60 * 60 * 1000; 

  // Função que executa o logoff automático
  const executarLogoff = async () => {
    // 1. Verifica se o usuário está realmente logado
    const token = localStorage.getItem('token');
    if (!token) return;

    console.warn("🕒 Sessão expirada por inatividade.");
    
    // 2. Limpa os dados de sessão imediatamente
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // 3. Só exibe o alerta e redireciona se não estiver na página de login
    if (location.pathname !== '/login') {
      // ✅ Alerta padronizado bonitinho
      await showWarning(
        "Sessão Expirada", 
        "Sua sessão expirou após 1 hora de inatividade por motivos de segurança."
      );
      
      // 4. Redireciona após o clique no botão do alerta
      navigate('/login');
    }
  };

  // Função para resetar o cronômetro de inatividade
  const resetarTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    
    // Só ativa o cronômetro se o usuário estiver logado
    if (localStorage.getItem('token')) {
      timerRef.current = setTimeout(executarLogoff, TEMPO_LIMITE);
    }
  };

  useEffect(() => {
    // Eventos que reiniciam a contagem (interação do usuário)
    const eventos = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

    resetarTimer();

    // Adiciona ouvintes para detectar atividade
    eventos.forEach(evento => {
      window.addEventListener(evento, resetarTimer);
    });

    // Limpeza ao desmontar o componente ou mudar de rota
    return () => {
      eventos.forEach(evento => {
        window.removeEventListener(evento, resetarTimer);
      });
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [location]); // Monitora mudanças de página para resetar a contagem

  return (
    <div className="app-container font-sans text-gray-700">
      <Routes>
        {/* 🌍 ROTA PÚBLICA: Mapa Principal */}
        <Route path="/" element={<Mapa />} />
        
        {/* 🔐 ROTA PÚBLICA: Tela de Login */}
        <Route path="/login" element={<Login />} />
        
        {/* 🏛️ ROTA PÚBLICA (VISUALIZAÇÃO): Detalhes da Obra 
            O controle de edição é feito internamente no componente pelo isAdmin */}
        <Route path="/empreendimento/:id" element={<DetalheEmpreendimento />} />

        {/* 🚫 ROTAS DE ERRO */}
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;